import React, { useState, useEffect } from "react";
import { BsCheckCircle } from "react-icons/bs";
import numeral from "numeral";
export default function Modal(props) {


    const [browserName, setBrowserName] = useState("");
    const [showModal, setShowModal] = useState(true);
    const [sistemaOP, setSistemaOP] = useState("");
    const userIp = props.info.userIp
    const title = "Retiro exitoso";
    const ref = props.retiroPk;

    const today = new Date();
    var ampm = today.getHours() >= 12 ? 'pm' : 'am';
    const comision_retiro = props.info.fee;
    const comision_iva_retiro = props.info.fee_iva;
    const gmf = props.info.gmf;
    const payed_amount = props.info.payed_amount;
    const amount = props.info.amount;

    const date = (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear() + ' - ' + today.getHours() + ':' + today.getMinutes() + ' ' + ampm;
    function enteroTransform(n) {
        var entero = Math.round(n);
        return entero;
    }
    useEffect(() => {
        getBrowserInfo()
    }, [])
    function FormatCOPNumber(amount, commas = false, showDecimals = true, id) {
        try {
            if (!amount && id === 1) return "$ 0";
            if (!amount && id === 2) return "";

            if (isNaN(parseFloat(amount))) {
                return id === 1 ? "$ 0" : "";
            }

            const numeroFormateado = parseFloat(amount).toLocaleString('es-CO', {
                style: 'currency',
                currency: 'COP'
            });

            const numeroParts = numeroFormateado.split(',');
            const parteEntera = numeroParts[0];
            const parteDecimal = numeroParts[1] ? `.${numeroParts[1]}` : '.00';

            if (id === 1) {
                return parteEntera;
            } else if (id === 2) {
                return parteDecimal;
            } else {
                return numeroFormateado;
            }
        } catch (error) {
            console.error("Error en FormatCOPNumber:", error);
            return "";
        }
    }
    const getBrowserInfo = async () => {

        if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
            setBrowserName('Opera');
        } else if (navigator.userAgent.indexOf("Chrome") != -1) {
            setBrowserName('Chrome');
        } else if (navigator.userAgent.indexOf("Safari") != -1) {
            setBrowserName('Safari');
        } else if (navigator.userAgent.indexOf("Firefox") != -1) {
            setBrowserName('Firefox');
        } else if ((navigator.userAgent.indexOf("MSIE") != -1) || (!!document.documentMode == true)) {
            setBrowserName('IE');
        } else {
            setBrowserName('Unknown');
        }

        if (navigator.appVersion.indexOf("Win") != -1) {
            setSistemaOP("Windows")
        }
        else if (navigator.appVersion.indexOf("Mac") != -1) {
            setSistemaOP("MacOS")
        }
        else if (navigator.appVersion.indexOf("X11") != -1) {
            setSistemaOP("UNIX")
        }
        else if (navigator.appVersion.indexOf("Linux") != -1) {
            setSistemaOP("Linux")
        }
        else if (navigator.appVersion.indexOf("Android") != -1) { setSistemaOP("Android") }
        else {
            setSistemaOP('Unknown')
        }
    }

    return (
        <>
            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"

                    >
                        <div className="relative w-pop-up my-6 mx-auto max-w-md">
                            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                <button
                                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                    onClick={() => setShowModal(false)}
                                >
                                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                        ×
                                    </span>
                                </button>
                                <div className="relative px-6 pb-1 flex-auto">
                                    <p className="text-xs font-bold text-trixel-popup centrar-contenido">REF - {ref}</p>
                                    <h3 className="text-3xl font-bold text-trixel-popup centrar-contenido">{title}</h3>
                                    <div className="flex justify-center items-center mt-4 mb-8">
                                        <img src={require('../../assets/images/approve.svg')} style={{ width: 75, height: 75 }} />
                                    </div>

                                    <div className="my-4 py-2 mb-1 text-gray-600 text-lg leading-relaxed border border-solid text-gray-700 rounded">
                                        <div className="flex items-center px-1 leading-7">
                                            <p className="rounded-full mr-4 text-sm w-6/12 text-left">Fecha y hora</p>
                                            <p className="rounded-full text-sm w-6/12 text-right">{date}</p>
                                        </div>
                                        <div className="flex items-center px-1 leading-7">
                                            <p className="rounded-full mr-4 text-sm w-6/12 text-left">Monto a debitar</p>
                                            <p className="rounded-full text-sm w-6/12 text-right">{FormatCOPNumber(payed_amount)}</p>
                                        </div>
                                        <div className="flex items-center px-1 leading-7">
                                            <p className="rounded-full mr-4 text-sm w-6/12 text-left">Monto a transferir</p>
                                            <p className="rounded-full text-sm w-6/12 text-right">{FormatCOPNumber(amount)}</p>
                                        </div>
                                        <div className="flex items-center px-1 leading-7">
                                            <p className="rounded-full mr-4 text-sm w-6/12 text-left">Comisión retiro</p>
                                            <p className="rounded-full text-sm w-6/12 text-right">{FormatCOPNumber(comision_retiro)}</p>
                                        </div>
                                        <div className="flex items-center px-1 leading-7">
                                            <p className="rounded-full mr-4 text-sm w-6/12 text-left">IVA comisión retiro</p>
                                            <p className="rounded-full text-sm w-6/12 text-right">{FormatCOPNumber(comision_iva_retiro)}</p>
                                        </div>
                                        <div className="flex items-center px-1 leading-7">
                                            <p className="rounded-full mr-4 text-sm w-6/12 text-left">GMF</p>
                                            <p className="rounded-full text-sm w-6/12 text-right">{FormatCOPNumber(gmf)}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="items-center justify-end p-2 border-gray-300 rounded-b">
                                    <p className="text-gray-700 text-center text-xs font-hairline">{userIp} -{browserName} {sistemaOP}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className=" fixed inset-0 z-40 " style={{
                        background: 'rgba(47, 46, 44, 0.5)',
                        backdropFilter: 'blur(10px)',
                    }}></div>
                </>
            ) : null}
        </>
    );
}